module.exports = __webpack_public_path__ + "static/media/fly0289.b31f03e7.webp";